module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by Shirley G. McQuillis Iscrupe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/section01"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")]), _vm._v(" I: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGONIER")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEY")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSROADS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/section01#h1"
    }
  }, [_vm._v("Loyalhanna: Indian Predecessors in the Ligonier Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/section01#h2"
    }
  }, [_vm._v("The Post at Loyalhanna: Path to Pittsburgh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/section01#h3"
    }
  }, [_vm._v("A Strategic Crossroads at Loyalhanna: Fighting for the Forks of the Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/section01#h4"
    }
  }, [_vm._v("George Washington: A Secondary Cast Member on the Global Stage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/section01#h5"
    }
  }, [_vm._v("History Continues at Fort Ligonier Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/section02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")]), _vm._v(" II: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGONIER")]), _vm._v(": A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTLED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMUNITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramseytown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Diamond: Gem of the Ligonier Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ligonier’s Metal Sentinel: The Diamond Drinking Fountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fostering Literary and Civic Improvement: The Ligonier Valley Library")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ligonier Opera House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/section03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")]), _vm._v(" III: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSE IN THE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEY")]), _vm._v(": L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGONIER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDUSTRIAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVOLUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Iron Horse: The Ligonier Valley Rail Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feeding the Steel Mills and Paving the Streets of Pittsburgh: Industry in the Ligonier Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ligonier Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/section04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")]), _vm._v(" IV: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILITARY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROES OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGONIER")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLEY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Clair Grove: A Common Area Named after an Uncommon Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Serious Game of Capture the Flag: Private John C. Ewing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost in the Great War: Privates William Tosh and Benjamin Byers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ultimate Sacrifice: Staff Sergeant Alvin P. Carey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lest We Forget: The Darlington District Honor Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Man of Passion: Brigadier General Kenneth R. Craig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/section05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTION")]), _vm._v(" V: R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OADS AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECREATION")]), _vm._v(": P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNSYLVANIA")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTAIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAYGROUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ligonier: “Pennsylvania’s Mountain Playground”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Scenic Spot on Western Pennsylvania Roadways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section05#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roadhouse Renaissance: The Washington Furnace Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section05#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idlewild Park: Where History Is Eternal and Nature Is King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/section05#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Sunday, Monday, Happy Days”: Teenage Hangouts in and around the Ligonier Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0